export default __webpack_public_path__ + "static/media/previousquestionseamcet.cb097786.jpeg";